//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const { modifyStyleLayers } = require('./layer-plugin');
const { modifyReference } = require('./gago-reference');

exports.styleLayerInit = function ({
    StyleLayer,
    styleSpec
}) {
    if (styleSpec) {
        modifyReference(styleSpec);
    }
    if (StyleLayer && StyleLayer.setLayer) {
        modifyStyleLayers(StyleLayer);
    }
};
